import PropTypes from 'prop-types';
import { richtextType } from './richtext';

export const linkPropertiesShape = {
  rel: PropTypes.string,
  gtm: PropTypes.shape({
    event: PropTypes.string,
    category: PropTypes.string,
    action: PropTypes.string,
    label: PropTypes.string,
    class: PropTypes.string,
  }),
};

export const linkPropertiesType = PropTypes.shape(linkPropertiesShape);

export const linkType = PropTypes.shape({
  target: PropTypes.string,
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(richtextType),
  ]),
  type: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  ...linkPropertiesShape,
});
